function updateDmzClass(): void {
  fetch('https://tools.rbb-online.de/tools-service/api/dmz')
    .then(response => response.json())
    .then((data: { dmz: boolean }) => {
      if (data.dmz) {
        document.body.classList.add('dmz');
      } else {
        document.body.classList.remove('dmz');
      }
    });
}

document.addEventListener('DOMContentLoaded', () => {
  updateDmzClass();
});
setInterval(updateDmzClass, 300000);
